<div class="bg-background-dark w-full md:px-16 py-4 pl-2">
    <div class="text-xl text-primary font-bold">{{ name() }}</div>
</div>

<div class="w-full md:px-16 py-4 pl-2">
    @for(entry of group().entries; track $index) {
    <app-accordion-item>
        <div accordionTitle class="text-lg">{{ entry.termPrimary }} / {{ entry.termSecondary }}</div>
        <app-glossary-entry accordionContent [entry]="entry"></app-glossary-entry>
    </app-accordion-item>
    }
</div>